// src/components/strumenti/CadutaTensioneDC.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const RESISTIVITA_RAME = 0.0178;

export default function CadutaTensioneDC() {
  const [tensione, setTensione] = useState("12");
  const [corrente, setCorrente] = useState("");
  const [lunghezza, setLunghezza] = useState("");
  const [sezione, setSezione] = useState("0.5");

  const V = leggiNumero(tensione)||0;
  const I = leggiNumero(corrente)||0;
  const L = leggiNumero(lunghezza)||0;
  const S = leggiNumero(sezione)||0;

  const puoCalcolare = I>0 && L>0 && S>0;
  // Linea a 2 fili (andata e ritorno): b=2
  const deltaV = puoCalcolare ? (2*RESISTIVITA_RAME*L*I)/S : null;
  const deltaVPerc = deltaV!==null && V>0 ? (deltaV/V)*100 : null;
  const tensioneResidua = deltaV!==null ? V-deltaV : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Tensione alimentazione (V)</label>
          <select value={tensione} onChange={e=>setTensione(e.target.value)} style={inp}>
            <option value="12">12 V</option>
            <option value="24">24 V</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Sezione cavo (mm²)</label>
          <select value={sezione} onChange={e=>setSezione(e.target.value)} style={inp}>
            {[0.22,0.35,0.5,0.75,1,1.5,2.5].map(s => <option key={s} value={s}>{s} mm²</option>)}
          </select>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Corrente assorbita (A)</label>
          <input value={corrente} onChange={e=>setCorrente(e.target.value)} style={inp} placeholder="Es. 0.5"/>
        </div>
        <div>
          <label style={lbl}>Lunghezza linea (m, solo andata)</label>
          <input value={lunghezza} onChange={e=>setLunghezza(e.target.value)} style={inp} placeholder="Es. 30"/>
        </div>
      </div>

      <div style={{ background:"#fef2f2", border:`1px solid ${deltaVPerc>10?"#fca5a5":"#fecaca"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Caduta di tensione</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#dc2626" }}>
          {deltaV===null ? "—" : `${deltaV.toLocaleString("it-IT",{maximumFractionDigits:2})} V`}
          {deltaVPerc!==null && <span style={{ fontSize:14, marginLeft:8, color:"#9ca3af" }}>({deltaVPerc.toLocaleString("it-IT",{maximumFractionDigits:1})}%)</span>}
        </div>
        {tensioneResidua!==null && (
          <div style={{ fontSize:12, color:"#6b7280", marginTop:6 }}>Tensione residua al dispositivo: <strong>{tensioneResidua.toLocaleString("it-IT",{maximumFractionDigits:2})} V</strong></div>
        )}
        {deltaVPerc!==null && deltaVPerc>10 && (
          <div style={{ fontSize:11, color:"#991b1b", marginTop:6 }}>Caduta elevata — molti dispositivi (sirene, sensori) richiedono una tensione minima di funzionamento: verificare il datasheet</div>
        )}
      </div>

      <button onClick={()=>{setCorrente("");setLunghezza("");setSezione("0.5");setTensione("12");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
